import React, { useState } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

const SentenceWindow = (props) => {

  const [sentenceWindowDisplay, setSentenceWindowDisplay] = useState("block");

  const handleClickOk = () => {
    setSentenceWindowDisplay("none");
  }

  const gameStatusInfoArea = css`

    display: ${sentenceWindowDisplay};
   position: absolute;
    top: 0;
    left: 0;
    width: ${window.innerWidth}px;
    height: ${window.innerHeight}px;
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background-color: rgba(191, 212, 235, 0.5);
    z-index: 100;
    .wordArea {
      animation-name: fadeInAnime;
      animation-duration:0.5s;
      animation-fill-mode:forwards;
      opacity: 0;
      @keyframes fadeInAnime{
        from {
          opacity: 0;

        }

        to {
          opacity: 1;

        }
      }
      color: #323232;
      filter: drop-shadow(3px 3px 5px rgba(0,0,0,0.7));
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #ffffffa1;
      text-align: center;
      width: 50vw;
      height: 200px;
      button {
          cursor: pointer;
          width: 110px;
          height: 50px;
      }
      p {
        margin-top: 45px;
        margin-bottom: 30px;
      }
    }
  `;


  return (
    <>
      <div css={gameStatusInfoArea}>
        <div className='wordArea'>
          <p>{props.sentence.completed_english_sentence}</p>
          <button onClick={handleClickOk}>OK</button>
        </div>
      </div>
    </>
  )
}

export default SentenceWindow
